import { call, getContext, put, take } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import { initAuthInfo, login, logout } from '../actions/app';
import * as gtmDataLayer from 'utils/gtmDataLayer';

// TODO: add refresh token watcher

function createAuthenticationChannel(authenticationModel) {
  return eventChannel(emitter => {
    authenticationModel.on('change:isAuthenticated', (model, value) => {
      emitter(value);
    });

    return () => {};
  });
}

function publishUserInfo(eventLabel, eventValue) {
  gtmDataLayer.push({
    eventAction: 'updateUserInfo',
    eventLabel,
    eventValue
  });
}

function* setUserInfo(init = false) {
  const app = yield getContext('app');

  const accessToken = yield call(() => app.authorization.getAccessToken());

  const { user_id } = app.authorization.getUserInfo();

  const userInfo = {
    id: user_id
  };

  setTimeout(() => {
    gtmDataLayer.pushVariables({
      event: 'updateUserInfo',
      userId: userInfo.id
    });
    publishUserInfo('id', userInfo.id);
  }, 2000);

  if (init) {
    yield put(initAuthInfo(user_id, accessToken, userInfo));
  } else {
    yield put(login(user_id, accessToken, userInfo));
  }
}

export function* authWatcher() {
  const app = yield getContext('app');
  const authorizationModel = app.authorization.getAuthenticationState();
  const channel = yield call(createAuthenticationChannel, authorizationModel);
  const apolloClient = yield getContext('apolloClient');

  while (true) {
    const isAuthenticated = yield take(channel);

    if (isAuthenticated) {
      yield call(setUserInfo);
    } else {
      gtmDataLayer.pushVariables({
        event: 'updateUserInfo',
        userId: null,
        userName: null,
        userEmail: null
      });
      yield put(logout());

      yield call(apolloClient.resetStore);
    }
  }
}

export default function* auth() {
  const app = yield getContext('app');

  yield call([app.authorization, 'getAuthorizationPromise']);

  if (app.authorization.isAuthenticated()) {
    yield call(setUserInfo, true);
  }
}



// WEBPACK FOOTER //
// ./src/sagas/auth.js